var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Vision",style:({
    '--background': ("url('" + (_vm.moData.swiper[0].link) + "') no-repeat"),
    backgroundSize: 'cover',
  }),on:{"click":function($event){return _vm.getModelPath(_vm.moData.swiper[0])}}})}
var staticRenderFns = []

export { render, staticRenderFns }